import React, { useEffect, useState } from 'react'
import { IconDoneCheck } from '@creditas-ui/react'
import { navigateToUrl } from 'single-spa'
import { useFeed } from 'lead/application'
import {
  FEED_ITEM_TITLE,
  FEED_ITEM_REJECTION_DESCRIPTION,
} from 'lead/domain/constants'
import { feedTitleKeys } from 'shared/helpers'
import { showFeedInspection } from 'shared/application/services/linkInspection'
import { DOCUMENT_PRODUCT_PATH } from 'domain/constants'

export const useCardFeed = lead => {
  const [iconFeed, setIconFeed] = useState(<IconDoneCheck strokeWidth={0.5} />)
  const [lastItem, setLastItem] = useState()
  const [currentStep, setCurrentStep] = useState(null)

  const { feedItems } = useFeed(lead)

  const getCurrentFeed = () => feedItems[0]
  const stepsLead = lead?.steps
    ?.filter(step => step.progress.startedAt !== undefined)
    .slice(-1)
    .pop().progress.startedAt

  const lastFeedItemName = lastItem?.name

  const lastFeedItem = {
    title: FEED_ITEM_TITLE[lastFeedItemName]?.title,
    subtitle: FEED_ITEM_TITLE[lastFeedItemName]?.subtitle,
    rejectionDescription:
      FEED_ITEM_REJECTION_DESCRIPTION[lastItem?.description],
  }

  const showDocumentsRequiredSubtitle =
    lastFeedItemName === feedTitleKeys.DOCUMENT_REQUIRED

  const showDocumentButton =
    lastFeedItemName === feedTitleKeys.DOCUMENTS_PENDING ||
    lastFeedItemName === feedTitleKeys.DOCUMENT_REQUIRED

  const sendDocumentButton = {
    enabled: showDocumentButton,
    handleClick: () => {
      const documentProduct = DOCUMENT_PRODUCT_PATH[lead.productType] || ''
      navigateToUrl(`/documents/${documentProduct.toString()}/${lead.id}`)
    },
  }

  const lastUpdate = feedItems.length === 0 ? stepsLead : lastItem?.createdAt

  const totalSteps = lead?.steps?.length
  const stepsFinished = lead?.steps?.filter(
    step => step.progress.finishedAt,
  ).length

  const stepsRejectionReason = lead?.steps?.filter(
    step => step.rejectionReason,
  ).length

  const changeLastItem = () => {
    if (feedItems.length === 0) {
      setLastItem({
        name: feedTitleKeys.DEFAULT_FEED_ANALYSIS,
      })
    } else {
      setLastItem(getCurrentFeed())
    }
  }

  const changeIconByFeedItems = (lastFeed, allFeeds) => {
    if (lastFeed && allFeeds.length !== 0) {
      setIconFeed(FEED_ITEM_TITLE[getCurrentFeed()?.name]?.icon)
    }
  }

  const showLinkInspection = showFeedInspection({
    feedItems,
    currentFeedName: getCurrentFeed()?.name,
  })

  useEffect(() => {
    if (stepsFinished === totalSteps || stepsRejectionReason >= 1) {
      setCurrentStep(stepsFinished)
    } else {
      setCurrentStep(stepsFinished + 1)
    }
  }, [lead])

  useEffect(() => {
    changeLastItem()
  }, [feedItems])

  useEffect(() => {
    changeIconByFeedItems(lastItem, feedItems)
  }, [lastItem])

  return {
    iconFeed,
    lastUpdate,
    totalSteps,
    currentStep,
    showLinkInspection,
    lastFeedItem,
    sendDocumentButton,
    showDocumentsRequiredSubtitle,
  }
}
